module.exports = __webpack_public_path__ + "static/media/faq-image-footer.3e726a35.png";